import script from "./ThankYouCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouCard.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouCard.vue?vue&type=style&index=0&id=2448b9be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2448b9be"]])

export default __exports__